import React from 'react'
import { Box, Typography } from '@mui/material'
import Divider from 'src/timeline/Divider'
import { advancedColors } from '../../theme'

type Props = { label?: string; isNew?: boolean; isOnTop?: boolean; flush?: boolean }

// Standard's unread divider is sticky, so a caller must not wrap it.
const DayDivider = ({ label, isNew = false, isOnTop = false, flush = false }: Props) =>
  isNew ? (
    <Divider showNewIndicator isOnTop={isOnTop} isHighlighted={!isOnTop} flush={flush}>
      {label}
    </Divider>
  ) : (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box sx={{ flex: 1, height: '1px', backgroundColor: advancedColors.line }} />
      <Typography variant="caption" sx={{ color: advancedColors.inkFaint, flexShrink: 0 }}>
        {label}
      </Typography>
      <Box sx={{ flex: 1, height: '1px', backgroundColor: advancedColors.line }} />
    </Box>
  )

export default DayDivider
